import { useMemo } from "react";
import { BOARD_DISPLAY_NAME } from "@/config/browserBoard";
import {
  type ConnectedApplicationsState,
  createConnectedApplicationsMediator,
  isConnectedApplicationsEvent,
} from "@/features/app-auth/connectedApplicationsMediator";
import { useAppAuthMetadata } from "@/features/app-auth/useAppAuthMetadata";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import type { EventNode, TypedEvent } from "@/shared/lib/componentHierarchy";
import {
  useComponentNode,
  useHierarchyLifetime,
  useMediatorSnapshot,
} from "@/shared/ui/component-hierarchy/hooks";

export function useConnectedApplicationsPresenter(): ConnectedApplicationsState & {
  node: EventNode<TypedEvent>;
} {
  useDocumentTitle(`接続済みアプリ - ${BOARD_DISPLAY_NAME}`);
  useAppAuthMetadata();
  const mediator = useMemo(() => createConnectedApplicationsMediator(), []);
  useHierarchyLifetime(mediator);
  const state = useMediatorSnapshot(mediator);
  const node = useComponentNode((event) => {
    if (!isConnectedApplicationsEvent(event)) return "unhandled";
    return mediator.dispatch(event).status === "handled"
      ? "handled"
      : "unhandled";
  });
  return { ...state, node };
}
